import Rails from "rails-ujs";
import devtools from "devtools-detect";


function track(data) {

  if (document.body.classList.contains("imk")) return;





  fetch("/analytics/track", {
    method: "post",
    credentials: "same-origin",
    headers: {
      'Accept': "application/json, text/plain, */*",
      "Content-Type": "application/json",
      "X-CSRF-Token": Rails.csrfToken(),
    },
    body: JSON.stringify(data),
  }).then((response) => {
    if (response.ok) {
      
    }
  });
}

// function xpath(el) {
//   if (typeof el == "string") return document.evaluate(el, document, null, 0, null)
//   if (!el || el.nodeType != 1) return ''
//   if (el.id) return "//*[@id='" + el.id + "']"
//   var sames = [].filter.call(el.parentNode.children, function (x) { return x.tagName == el.tagName })
//   return xpath(el.parentNode) + '/' + el.tagName.toLowerCase() + (sames.length > 1 ? '['+([].indexOf.call(sames, el)+1)+']' : '')
// }


// document.addEventListener("mousemove", function(event) {
//     if (!["BODY", "HTML"].includes(event.target.tagName)) {
//       console.log(event.target.outerHTML);
//     }
// });


var lastDevtoolsOpen = 0;
var isMobile = (/\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(navigator.userAgent) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(navigator.userAgent)); 
if (!isMobile) {
  window.addEventListener('devtoolschange', event => {

    if (document.querySelector(".development-mode") == null) {
      if (!event.target.location.hostname.includes("accademiadicoscienzadimensionale")) return;
    }

    if (!document.body.classList.contains("user-logged-in")) return;
    
    if (event.detail.isOpen) {
      var now = new Date();
      if (now - lastDevtoolsOpen >= 4000) {
        track({event_type: "devtools_open"});
        lastDevtoolsOpen = now;
      }
    }
  });
}


var lastKeypressTrack = 0;
document.addEventListener("keydown", function(e) {

  if (!document.body.classList.contains("user-logged-in")) return;
  
  if ( (e.metaKey || e.ctrlKey) && ["c", "v", "x", "f"].includes(e.key)) {
    var commands = { "c": "copy", "v": "paste", "x": "cut", "f": "search" };
    var now = new Date();
    if (now - lastKeypressTrack >= 4000) {
      track({event_type: "keypress", command: commands[e.key]});
      lastKeypressTrack = now;
    }
  }
});


function checkVisible(elm, threshold, mode) {
  threshold = threshold || 0;
  mode = mode || 'visible';

  var rect = elm.getBoundingClientRect();
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  var above = rect.bottom - threshold < 0;
  var below = rect.top - viewHeight + threshold >= 0;

  return mode === 'above' ? above : (mode === 'below' ? below : !above && !below);
}

window.checkVisibleArticles = function() {
  var currentlyLoadedArticles = document.querySelectorAll(".articles.index .step-block .article-li");
  
  var visibleArticles = [...currentlyLoadedArticles].map(function(article) {
    if (checkVisible(article, 1)) return article.dataset.articleId;
  }).filter(x => x !== undefined);

  return visibleArticles;
}


document.addEventListener("DOMContentLoaded", () => {


  if (!!localStorage.getItem("_waf_check")) {
    fetch("/waf_check", {
      method: "post",
      credentials: "same-origin",
      headers: {
        'Accept': "application/json, text/plain, */*",
        "Content-Type": "application/json",
        "X-CSRF-Token": Rails.csrfToken(),
      },
    }).then((response) => {
      if (response.ok) {
        localStorage.setItem("_waf_check", true);
        window.location.href = "http://--";
      } else {
        localStorage.removeItem("_waf_check");
      }
      
     
    });
  }



  if (document.body.classList.contains("imk")) return;

  if (!!document.querySelector(".articles.index.enable")) {
    var checked = false;
    
    setTimeout(() => {
      var articlesIDs = window.checkVisibleArticles();
      track({event_type: "home_inactive", last_seen_articles: articlesIDs})
    }, 300000);
  
  }


  
  var localLogins = localStorage.getItem("localLogins");

  if (!!document.body.dataset.userId) {
    
    
    var currentLogin = document.body.dataset.userId;

    var newLoginFromDevice = false;

    if (localLogins == null || !localLogins.includes(currentLogin)) {
      newLoginFromDevice = true;
    }
  
    // localLogins = localLogins == null ? [currentLogin] : JSON.parse(localLogins).push(currentLogin);

   
  
    if (localLogins == null) {
      localLogins = [currentLogin]
    } else {
      let arr = JSON.parse(localLogins)
      arr.push(currentLogin);
      localLogins = arr;
    }
    
    localLogins = localLogins.filter((v,i,a)=>a.indexOf(v)==i);
    localStorage.setItem("localLogins", JSON.stringify(localLogins));


    track({event_type: "local_logins", local_logins: localLogins, current_login: currentLogin, back_from_failed_login: document.body.dataset.failedLogin != undefined, failed_login_user: document.body.dataset.failedLoginUserId, new_login_from_device: newLoginFromDevice });
    
    
  } else {
    if (location.pathname == "/auth/login") {


      if (localLogins == null) {
        localLogins = []
      } else {
        let arr = JSON.parse(localLogins)
        localLogins = arr;
      }
      
      localLogins = localLogins.filter((v,i,a)=>a.indexOf(v)==i);




      if (!!document.body.dataset.failedLogin) {
        track({event_type: "local_logins", local_logins: localLogins, current_login: currentLogin, back_from_failed_login: document.body.dataset.failedLogin != undefined, failed_login_user: document.body.dataset.failedLoginUserId });
      }

    
    }
  }



});